export enum SeverityType {
    Error = "Error",
    Warning = "Warning",
    Info = "Info",
    Success = "Success",
};